import { render, staticRenderFns } from "./UINotification.vue?vue&type=template&id=4670b66a"
import script from "./UINotification.vue?vue&type=script&lang=js"
export * from "./UINotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports